module.exports = __webpack_public_path__ + "static/img/dr_anupam_mitra_photo.8a26bb18.png";